import { render, staticRenderFns } from "./ParticipacaoValorTotalDespesasPercentual.vue?vue&type=template&id=68fc764b&scoped=true&"
import script from "./ParticipacaoValorTotalDespesasPercentual.vue?vue&type=script&lang=js&"
export * from "./ParticipacaoValorTotalDespesasPercentual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc764b",
  null
  
)

export default component.exports